/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Remove_User_MessageInputs */

const en_admin_company_detail_remove_user_message = /** @type {(inputs: Admin_Company_Detail_Remove_User_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove this user from the company? They will lose access to company resources.`)
};

const de_admin_company_detail_remove_user_message = /** @type {(inputs: Admin_Company_Detail_Remove_User_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie diesen Benutzer aus dem Unternehmen entfernen? Der Benutzer verliert dadurch den Zugriff auf Unternehmensressourcen.`)
};

/**
* | output |
* | --- |
* | "Remove this user from the company? They will lose access to company resources." |
*
* @param {Admin_Company_Detail_Remove_User_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_remove_user_message = /** @type {((inputs?: Admin_Company_Detail_Remove_User_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Remove_User_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_remove_user_message(inputs)
	return en_admin_company_detail_remove_user_message(inputs)
});